import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Container as Grid } from 'react-bootstrap'

import style from './style.css'

export default function FooterBar (props) {
  let styleContainer
  let styleProp = null

  if (props.legacyEbook === true) {
    styleContainer = style.legacySplitContainer
  } else if (props.splitPane) {
    styleContainer = style.splitContainer
    if (props.width) {
      styleProp = {
        width: 'calc(100% - 10px - ' + props.width + 'px)'
      }
    }
  } else {
    styleContainer = style.container
  }
  return (
    <div
      className={classnames(styleContainer, props.className)}
      style={styleProp}
      role="contentinfo"
    >
      <Grid>
        {props.children}
      </Grid>
    </div>
  )
}
FooterBar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  splitPane: PropTypes.bool,
  legacyEbook: PropTypes.bool,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

export function CenterRoundButton (props) {
  const { children, className, ...restProps } = props
  return (
    <button
      {...restProps}
      className={classnames(style.centerRoundButton, className)}
      role="button"
    >
      {children}
    </button>
  )
}
CenterRoundButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}
